<div *transloco="let t" class="py-4 h-full flex flex-col justify-between">
  <!-- Menu Links -->
  <div
    id="links"
    class="px-4 flex-grow max-h-[800px] overflow-y-auto pb-8 flex flex-col gap-2"
  >
    @for (item of menuItems; track item) {

    <ng-container>
      <ng-container
        *ngTemplateOutlet="
          menuItemTemplate;
          context: { item: item, currentDepth: 0 }
        "
      ></ng-container>
    </ng-container>

    }

    <ng-template
      #menuItemTemplate
      let-item="item"
      let-currentDepth="currentDepth"
    >
      @if (!item.children) {

      <a
        [routerLink]="item.href"
        [queryParamsHandling]="null"
        [ngClass]="{
          'bg-primary/10 rounded-full text-primary font-semibold': isActive(
            item.href || ''
          )
        }"
        class="px-4 py-3 flex items-center gap-4 hover:bg-primary/10 hover:text-primary hover:rounded-full text-sm relative"
        [style.padding-left]="currentDepth * 16 + 16 + 'px'"
      >
        <i [ngClass]="item.icon"></i>
        {{ item.label }}
      </a>

      } @else {

      <div class="relative">
        <div
          (click)="item.expanded = !item.expanded"
          class="px-4 py-3 flex items-center justify-between gap-4 hover:bg-primary/10 hover:text-primary hover:rounded-full cursor-pointer text-sm relative"
          [style.padding-left]="currentDepth * 16 + 16 + 'px'"
        >
          <i [ngClass]="item.icon"></i>
          {{ item.label }}
          <i
            class="pi ms-auto"
            [ngClass]="{
              'pi-chevron-down': item.expanded,
              'pi-chevron-right': !item.expanded
            }"
          ></i>
        </div>

        @if (item.expanded) {
        <div class="flex flex-col">
          @for (child of item.children; track child) { @if (!child.children) {

          <a
            [routerLink]="child.href"
            [queryParams]="{}"
            [ngClass]="{
              'bg-primary/10 rounded-full text-primary font-semibold': isActive(
                child.href || ''
              )
            }"
            class="px-4 py-3 flex items-center gap-4 hover:bg-primary/10 hover:text-primary hover:rounded-full text-sm relative"
            [style.padding-left]="currentDepth * 16 + 32 + 'px'"
          >
            <div class="flex items-center gap-4 ps-4">
              <i style="font-size: 0.5rem" [ngClass]="child.icon"></i>
              {{ child.label }}
            </div>
          </a>

          } @else {

          <ng-container
            *ngTemplateOutlet="
              menuItemTemplate;
              context: { item: child, currentDepth: currentDepth + 1 }
            "
          ></ng-container>

          } }
        </div>
        }
      </div>

      }
    </ng-template>
  </div>

  <!-- Footer -->
  <div id="footer" class="m-4 p-2 bg-[#f1f5f9] rounded-xl flex items-center">
    <p-image
      [src]="baseUrl + laundry().image"
      alt="Logo"
      width="50"
      [preview]="true"
      imageClass="rounded-xl h-[50px]"
    />
    <div class="ms-2">
      <h4 class="text-[#00904a] text-[15px] font-semibold">
        {{ laundry().name | slice : 0 : 12 }}
        {{ laundry().name.length > 13 ? '...' : '' }}
      </h4>
      @if (userData.role === LAUNDRY_MANAGER) {
      <a
        class="text-[12px] text-[#a2a7ac]"
        [routerLink]="links.laundryDetails()"
        >{{ t('shared/showDetails') }}
      </a>
      }
    </div>
  </div>
</div>
